import React, { useEffect, FC, PropsWithChildren } from 'react'
import { useSelector } from 'react-redux'
import { configActions } from '../../../../ducks/actions'
import { useAppDispatch } from '../../../../ducks/hooks'
import {
  getError,
  getUser,
  isAuthorized,
} from '../../../../ducks/selectors'
import ErrorPage from '../../Pages/ErrorPage'
import InitializeGoogleAnalytics from 'helpers/google-analytics'
import { datadogRum } from 'helpers/datadogRUM-init'

const MainWrapper: FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useAppDispatch()
  const error = useSelector(getError())
  const user = useSelector(getUser)

  useEffect(() => {
    if (!navigator.onLine) {
      dispatch(configActions.setError({ show: true, type: 'no_internet' }))
    } else {
      dispatch(configActions.setError({ show: false, type: '' }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    InitializeGoogleAnalytics()
  }, [])

  useEffect(() => {
    const authorized = isAuthorized()
    const hasUserId = Boolean(user?.id)

    if (authorized && hasUserId) {
      const fullName = `${user.firstName} ${user.lastName}`.trim()
      const primaryEmail =
        user.email?.[0]?.email || user.emailString || ''

      datadogRum.setUser({
        id: user.id,
        name: fullName || undefined,
        email: primaryEmail || undefined,
        type: user.type,
        clientType: user.clientType,
      })
    } else {
      datadogRum.clearUser()
    }
  }, [user])

  window.addEventListener('online', () => {
    dispatch(configActions.setError({ show: false, type: '' }))
  })

  window.addEventListener('offline', () => {
    dispatch(configActions.setError({ show: true, type: 'no_internet' }))
  })

  return <main>{error.show ? <ErrorPage type={error.type} /> : children}</main>
}

export default MainWrapper
